/**
 * Map common airline display names to IATA codes for live-status lookups.
 * Prefer an explicit airline_code on the leg when present.
 */
const AIRLINE_NAME_TO_IATA = {
  'american airlines': 'AA',
  american: 'AA',
  'british airways': 'BA',
  'united airlines': 'UA',
  united: 'UA',
  'delta air lines': 'DL',
  'delta airlines': 'DL',
  delta: 'DL',
  'southwest airlines': 'WN',
  southwest: 'WN',
  jetblue: 'B6',
  'jetblue airways': 'B6',
  'alaska airlines': 'AS',
  alaska: 'AS',
  lufthansa: 'LH',
  'air france': 'AF',
  klm: 'KL',
  'qatar airways': 'QR',
  qatar: 'QR',
  emirates: 'EK',
  'etihad airways': 'EY',
  etihad: 'EY',
  'singapore airlines': 'SQ',
  'cathay pacific': 'CX',
  'japan airlines': 'JL',
  jal: 'JL',
  ana: 'NH',
  'all nippon airways': 'NH',
  'turkish airlines': 'TK',
  'air canada': 'AC',
  'qantas': 'QF',
  'virgin atlantic': 'VS',
  'iberia': 'IB',
  'ryanair': 'FR',
  'easyjet': 'U2',
  'norwegian': 'DY',
  'alaska air': 'AS',
  'hawaiian airlines': 'HA',
  hawaiian: 'HA',
  spirit: 'NK',
  'spirit airlines': 'NK',
  frontier: 'F9',
  'frontier airlines': 'F9',
  'aer lingus': 'EI',
  'swiss': 'LX',
  'swiss international air lines': 'LX',
  'austrian airlines': 'OS',
  'finnair': 'AY',
  'sas': 'SK',
  'scandinavian airlines': 'SK',
  'air new zealand': 'NZ',
  'korean air': 'KE',
  'asiana airlines': 'OZ',
  'china airlines': 'CI',
  'china eastern': 'MU',
  'china southern': 'CZ',
  'air china': 'CA',
  'latam': 'LA',
  'latam airlines': 'LA',
  'copa airlines': 'CM',
  'avianca': 'AV',
  'tap air portugal': 'TP',
  'tap portugal': 'TP',
  'aeromexico': 'AM',
  'westjet': 'WS',
  'porter airlines': 'PD',
  'vueling': 'VY',
  'wizz air': 'W6',
  'indigo': '6E',
  'air india': 'AI',
  'eva air': 'BR',
  'thai airways': 'TG',
  'malaysia airlines': 'MH',
  'philippine airlines': 'PR',
  'garuda indonesia': 'GA',
  'vietnam airlines': 'VN',
  'el al': 'LY',
  'egyptair': 'MS',
  'royal jordanian': 'RJ',
  'saudiarabian airlines': 'SV',
  'saudia': 'SV',
  'royal air maroc': 'AT',
  'south african airways': 'SA',
  'ethiopian airlines': 'ET',
  'kenya airways': 'KQ',
};

export const resolveAirlineIata = (airline, airlineCode = '') => {
  const code = String(airlineCode || '').trim().toUpperCase();
  if (/^[A-Z0-9]{2,3}$/.test(code)) {
    return code;
  }

  const raw = String(airline || '').trim();
  if (!raw) return null;
  if (/^[A-Za-z0-9]{2,3}$/.test(raw)) {
    return raw.toUpperCase();
  }

  return AIRLINE_NAME_TO_IATA[raw.toLowerCase()] || null;
};

/**
 * Normalize an airline field value to IATA when the name is known
 * (e.g. "Emirates" / "EMIRATES" → "EK"). Unknown values stay as entered.
 */
export const normalizeAirlineField = (airline, airlineCode = '') => {
  const resolved = resolveAirlineIata(airline, airlineCode);
  if (resolved) {
    return resolved;
  }
  const raw = String(airline || '').trim();
  return raw ? raw.toUpperCase() : '';
};
